import React from 'react';

import { ExternalLink } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import { isPublicMoorageListing } from '../../util/listingHelpers';
import {
  normalizeHarbormasterWebsite,
  sanitizeHarbormasterPhoneForTel,
} from '../../util/publicMoorageActions';

import css from './ListingPage.module.css';

const PublicMoorageActions = props => {
  const { publicData = {}, onCheckIn, showCheckIn = true } = props;

  if (!isPublicMoorageListing(publicData)) {
    return null;
  }

  const harbormasterPhone =
    typeof publicData?.harbormasterPhone === 'string'
      ? publicData.harbormasterPhone.trim()
      : '';
  const harbormasterPhoneHref = sanitizeHarbormasterPhoneForTel(harbormasterPhone);
  const normalizedHarbormasterWebsite = normalizeHarbormasterWebsite(
    publicData?.harbormasterWebsite
  );

  if (!showCheckIn && !harbormasterPhoneHref && !normalizedHarbormasterWebsite) {
    return null;
  }

  return (
    <>
      {showCheckIn ? (
        <>
          <button className={css.publicMoorageCheckInButton} type="button" onClick={onCheckIn}>
            <span>
              <FormattedMessage id="ListingPage.publicMoorageCheckIn" />
            </span>
            <small>
              <FormattedMessage id="ListingPage.publicMoorageCheckInSubtitle" />
            </small>
          </button>
          <p className={css.publicMoorageDisclaimer}>
            <FormattedMessage id="ListingPage.publicMoorageDisclaimerVisibility" />
            <br />
            <FormattedMessage id="ListingPage.publicMoorageDisclaimerRules" />
          </p>
        </>
      ) : null}
      {harbormasterPhone && harbormasterPhoneHref ? (
        <a className={css.callHarbormasterButton} href={`tel:${harbormasterPhoneHref}`}>
          <FormattedMessage id="ListingPage.callHarbormaster" />
        </a>
      ) : null}
      {normalizedHarbormasterWebsite ? (
        <ExternalLink className={css.moreInfoButton} href={normalizedHarbormasterWebsite}>
          <FormattedMessage id="ListingPage.moreInfo" />
        </ExternalLink>
      ) : null}
    </>
  );
};

export default PublicMoorageActions;
